import React from "react";
import { Route } from "react-router-dom";
import Dashboard from "../features/ACS-Dashboard-Modules/Main-Dashboard";
import Orders from "../features/ACS-Dashboard-Modules/Orders";
import Inventory from "../features/ACS-Dashboard-Modules/Inventory";
import Messages from "../features/ACS-Dashboard-Modules/Messages";
import Shipments from "../features/ACS-Dashboard-Modules/Shipment";
import Contracts from "../features/ACS-Dashboard-Modules/Contracts";
import Invoices from "../features/ACS-Dashboard-Modules/Invoice";
import DocumentUploader from "../features/ACS-Dashboard-Modules/DocumentUploader";
import Appointments from "../features/ACS-Dashboard-Modules/Appointments";
import ManageTeam from "../features/ACS-Dashboard-Modules/Manage-Team";
import NotificationCenter from "../features/ACS-Dashboard-Modules/NotificationCenter";
import Locations from "../features/ACS-Dashboard-Modules/Locations";
import ProtectedRoute from "../guard/ProtectedRoute";
import NotFoundPage from "../features/ACS-Auth/NotFoundPage";
import ResourceSelection from "../features/ACS-Dashboard-Modules/Resource-Selection";
import TransactionAudit from "../features/ACS-Dashboard-Modules/TransactionAudit";

/**
 * Child routes for {@link DashboardLayout} — declared once under /dashboard (no nested &lt;Routes&gt;),
 * so location changes always swap the outlet page (avoids stale view when leaving Resource Selection).
 */
export const dashboardChildRoutes = (
  <>
    <Route
      index
      element={
        <ProtectedRoute module="dashboard">
          <Dashboard />
        </ProtectedRoute>
      }
    />

    <Route
      path="orders"
      element={
        <ProtectedRoute module="orders">
          <Orders />
        </ProtectedRoute>
      }
    />

    <Route
      path="inventory"
      element={
        <ProtectedRoute module="inventory">
          <Inventory />
        </ProtectedRoute>
      }
    />

    <Route
      path="messages"
      element={
        <ProtectedRoute module="messages">
          <Messages />
        </ProtectedRoute>
      }
    />

    <Route
      path="shipments"
      element={
        <ProtectedRoute module="shipment">
          <Shipments />
        </ProtectedRoute>
      }
    />

    <Route
      path="contracts"
      element={
        <ProtectedRoute module="contracts">
          <Contracts />
        </ProtectedRoute>
      }
    />

    <Route
      path="invoices"
      element={
        <ProtectedRoute module="invoices">
          <Invoices />
        </ProtectedRoute>
      }
    />

    <Route
      path="upload"
      element={
        <ProtectedRoute module="upload">
          <DocumentUploader />
        </ProtectedRoute>
      }
    />

    <Route
      path="appointments"
      element={
        <ProtectedRoute module="appointments">
          <Appointments />
        </ProtectedRoute>
      }
    />

    <Route
      path="manage-team"
      element={
        <ProtectedRoute module="manage-team">
          <ManageTeam />
        </ProtectedRoute>
      }
    />

    <Route
      path="notifications"
      element={
        <ProtectedRoute module="notifications">
          <NotificationCenter />
        </ProtectedRoute>
      }
    />

    <Route
      path="locations"
      element={
        <ProtectedRoute module="locations">
          <Locations />
        </ProtectedRoute>
      }
    />

    <Route
      path="transaction-audit"
      element={
        <ProtectedRoute module="transaction-audit">
          <TransactionAudit />
        </ProtectedRoute>
      }
    />

    <Route
      path="resource-selection"
      element={
        <ProtectedRoute module="resource-selection">
          <ResourceSelection />
        </ProtectedRoute>
      }
    />

    <Route path="*" element={<NotFoundPage inDashboard />} />
  </>
);

/** @deprecated Use dashboardChildRoutes under DashboardLayout in App.js */
const DashboardRoutes = () => null;

export default DashboardRoutes;
